import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { makeSelectMode } from '~data/selectors/bookmarks'

import { HeaderTitle as TitleWrap, HeaderSpace as Space, Header } from '~ui'
import Title from './title'
import AddTags from './addTags'
import Move from './move'
import Checkbox from './checkbox'
import More from './more'
import Remove from './remove'
import Open from './open'
import Export from '../../export/button'
import Working from './working'
import Cancel from './cancel'

export default function BookmarksSelectMode(props) {
    const { spaceId } = props
    const getSelectMode = useMemo(() => makeSelectMode(), [])
    const selectMode = useSelector(state => getSelectMode(state, spaceId))

    const childProps = { ...props, selectMode }

    if (selectMode.working)
        return <Working {...childProps} />

    return (
        <Header data-solid>
            <Checkbox {...childProps} />
            <TitleWrap><Title {...childProps} /></TitleWrap>

            <Space />

            <Move {...childProps} />
            <AddTags {...childProps} />
            <Remove {...childProps} />
            <Export variant='outline' {...childProps} />
            <Open {...childProps} />
            <More {...childProps} />

            <Space />

            <Cancel {...childProps} />
        </Header>
    )
}
